import assetUrl from "@/vars/assetUrl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fragment } from "react";
import Emoji from "./Emoji";
import { getIconByKey } from "./microsite/icons";

type Props = {
  icon: string;
  iconSize?: string;
  imgSize?: string;
};

const RenderIcon = ({ icon, iconSize, imgSize }: Props) => {
  return (
    <Fragment>
      {icon.startsWith("icon:") ? (
        <FontAwesomeIcon
          icon={getIconByKey(icon)?.icon as any}
          className="w-6 text-xl"
          style={{ width: iconSize || "1.5em" }}
        />
      ) : icon.startsWith("emoji:") ? (
        <div className="p-2">
          <Emoji id={icon.split("emoji:")[1]} size={iconSize || "1.5em"} />
        </div>
      ) : (
        <img
          src={`${assetUrl}${icon}`}
          className="w-full"
          alt="icon"
          style={{
            width: imgSize,
          }}
        />
      )}
    </Fragment>
  );
};

export default RenderIcon;
